import * as React from 'react';
import { useEffect, useRef } from 'react';
import { alpha } from '@mui/material/styles';
import {
  Box,
  Typography,
  Paper,
  Container
} from '@mui/material';

export default function BoostMarketing(props) {
  const pricingTableRef = useRef(null);

  useEffect(() => {
    // Load Stripe script
    const script = document.createElement('script');
    script.src = 'https://js.stripe.com/v3/pricing-table.js';
    script.async = true;
    document.body.appendChild(script);

    // Inject custom element once script is ready
    script.onload = () => {
      if (pricingTableRef.current && !pricingTableRef.current.firstChild) {
        const pricingTable = document.createElement('stripe-pricing-table');
        pricingTable.setAttribute('pricing-table-id', 'prctbl_1Rj04vJe0QwMbMTs6pi5r22P');
        pricingTable.setAttribute('publishable-key', 'pk_live_51RVuaaJe0QwMbMTsm5U2EzI2Nd6tC8KHkpfFriwLkmSvq17n0KxAZYCgO8S2Jz4uAXR0xz5vuvamVSUiNbNByKZY00GY3FBTRd');
        pricingTableRef.current.appendChild(pricingTable);
      }
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' }, mx: 'auto' }}>
      <Typography variant="body1" sx={{ color: 'text.secondary', fontWeight: 600, mt: 2 }}>
        Boost Marketing
      </Typography>
      <Box
        component="main"
        sx={(theme) => ({
          flexGrow: 1,
          backgroundColor: theme.vars
            ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
            : alpha(theme.palette.background.default, 1),
          overflow: 'auto',
          p: 3,
        })}
      >
        <Container maxWidth="md">
          <Box display="flex" justifyContent="center">
            <Paper
              elevation={3}
              sx={{
                p: 4,
                borderRadius: 2,
                width: '100%',
                maxWidth: 700,
              }}
            >
              <Typography component="h2" variant="h4" gutterBottom align="center">
                Power Up Your Listing Visibility
              </Typography>
              <Typography variant="body1" paragraph align="center">
                Choose the Rocket Offer marketing boost plan below. Marketing Boost helps to expand reach,
                attract buyers, and grow interest in your property.
              </Typography>

              <Box ref={pricingTableRef} sx={{ mt: 4 }} />
            </Paper>
          </Box>
        </Container>
      </Box>
    </Box>
  );
}
